/* src/app/notification-alert/alert.component.scss */
.toast-container {
  position: fixed;
  top: 85px;
  right: 24px;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 360px;
  max-width: calc(100vw - 32px);
  pointer-events: none;
}
.app-toast {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  pointer-events: auto;
  animation: toastSlideIn 0.3s ease;
}
.app-toast .toast-icon {
  width: 34px;
  height: 34px;
  min-width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 15px;
}
.app-toast .toast-message {
  flex: 1;
  min-width: 0;
}
.app-toast .toast-message .toast-title {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
}
.app-toast .toast-message p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: #64748b;
  overflow-wrap: anywhere;
}
.app-toast .toast-close {
  border: 0;
  background: transparent;
  color: #94a3b8;
  padding: 2px;
  cursor: pointer;
  transition: color 0.2s ease;
}
.app-toast .toast-close:hover {
  color: #1f2937;
}
.app-toast.toast-success {
  border-left: 4px solid #16a34a;
}
.app-toast.toast-success .toast-icon {
  color: #16a34a;
  background: #dcfce7;
}
.app-toast.toast-danger {
  border-left: 4px solid #dc2626;
}
.app-toast.toast-danger .toast-icon {
  color: #dc2626;
  background: #fee2e2;
}
.app-toast.toast-warning {
  border-left: 4px solid #d97706;
}
.app-toast.toast-warning .toast-icon {
  color: #d97706;
  background: #fef3c7;
}
.app-toast.toast-info {
  border-left: 4px solid #2563eb;
}
.app-toast.toast-info .toast-icon {
  color: #2563eb;
  background: #dbeafe;
}
@keyframes toastSlideIn {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@media (max-width: 576px) {
  .toast-container {
    top: 70px;
    right: 12px;
    left: 12px;
    width: auto;
    max-width: none;
  }
}
/*# sourceMappingURL=alert.component.css.map */
